import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const NotificationPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default NotificationPage